$(document).ready(function(){

  var select_size = $('.product_variant_options input:checked').val();
  var length = $('.product_variant_size').length;

  var selected_bundle_size = select_size;
  selected_size(length, select_size);
  
  function selected_size(length , current_size)
  {
      for(var j=1;j<=length;j++)
      {
         var size_id = $('.bundle_variant-'+j+' option[data-option="'+current_size+'"]').attr('options-id');   
         $('.bundle-product-'+j).attr('data-variant',+size_id);
      }
    
      var main_variant_id = $('.main_prd_variant option[var-size="'+current_size+'"]').attr('var-id');
      $('.bundle_add_btn').attr('variant-id',+main_variant_id);
    
  }
  
  $('.product_variant_options label').click(function() {

      var current_size = $(this).find('span.js-value').text();
      selected_size(length, current_size)
      selected_bundle_size = current_size;
    
  });

  $('.bundle_add_btn').click(function() {
    
    var bundle_variant_id = [];
    var bundle_product_quantites = $('.bundle_product_packs').attr('bundle-packs');
    var properties = [];
    if($('.bundle_item').length > 0)
    {
      $('.bundle_item').each(function() {
          var var_id = $(this).attr('data-variant');
          var b_titles = $(this).attr('bundle-title');
          var b_images = $(this).find('img').attr('src');
          var b_packs = $('.bundle_product_packs').attr('bundle-packs');
          properties.push({b_titles,b_images,selected_bundle_size, b_packs});
          bundle_variant_id.push(var_id);
      });
    }
    else
    {
          var b_packs = $('.bundle_product_packs').attr('bundle-packs');
           properties.push({b_packs});
    }
    var formData = {
        items: []
    };

    // for (var i = 0; i < bundle_variant_id.length; i++) {
    //     formData.items.push({
    //         id: bundle_variant_id[i],
    //         quantity: 1,
    //          properties: {
    //             '_Bundle': 'true'
    //         }
    //     });
    // }
    
      formData.items.push({
            id: $(this).attr('variant-id'),
            quantity: bundle_product_quantites,
            properties: { "Bundle": properties }
        });
    
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        success: function(data) {
          window.location.href = 'https://revertapparel.com/cart'
        }
    });
  });

});
